import { LitElement, css, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';

// ─── App Configuration ────────────────────────────────────────────────────────
const APP_NAME     = 'Rokokbet';
const APP_DEV      = 'PT Rokok Nusantara';
const APP_ICON     = 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEihmUNf6Vs3wOysI2J4Wx1Zb_gvYNmUd6RpV9Yu2zD3sQ9gBu9tvtGc9TLOBbrmbFuqtNsQCmiqsBUo7NqKCtOqsmTD8rHRHsOcStZtIAtpSlZqMTYcALCjUO1QqoAZpINJgSscLPg4nH8gS0VECREdrN5RZ7Is27ddsHOcSLsP0WHWosm07cZ2_qpBAcC7/w200-h200/icon-circle.png';
const REDIRECT_URL = '/app.html';
const RATING       = '5.0';
const REVIEW_COUNT = '12,847';
const DOWNLOADS    = '500K+';
const AGE_RATING   = '18+';

const SCREENSHOTS = [
  'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiSK4R1TrfwNZ8A4sRHoWfjb0PbFbupEHx04FqtzzPEJg6X-lh05ms6zZESclV2V6uMo7UJNBr-qMZluzWK1s3vkdLoJ3biFtb_ziTuecu1fZ67XYnq3Qboe684XuvETzn0DJ00-8HTTM93O8ARKjyXrhjtOZUrsP0VEiZ_ULtD66SXsVAwuvPWeQxXh7yc/w640-h560/rokokbet-situs-toto.png',
  'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhT0p0KcHruXu71EEmtJp4Fb0UiFoodY3tZ8BvRCm7-p9D1R79hiAQCnlp72mgM7hkKYcrEjtsvHOIAoWiDSSrrIe-Z57DNy4yRqMCwN1k-_4eUZvgbjWbmPoYHgo3vDlZGjQIBuwx4jXftYnXoeqt5HkxafEhGlhfC86rla7zyy_Bu2g3XUdSpHVHQ2wQH/s16000/rokokbet-situs-toto.png',
  'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhzukJGdqR-LRUbMDLip0lktZF2yY4hwUWovDaAob4uu_C2L5YzNc-_d_L_ndo-iTDNwjTOuJFr2YbCLDBntaqTat7-RKAKYb-N_bR8xS2YGHEVoQZfmEwo-CDOvrURjKQqprP8vUH682_wVRwW0u6SjnBIbGAw1wmW7ewWt0euIFbcTCgb38vV6NxH6R6e/w640-h640/1.webp',
];

const DESCRIPTION = `Selamat datang di ${APP_NAME}, platform terbaik untuk pengalaman bermain yang seru dan menguntungkan! 🎰✨

Rasakan sensasi permainan dengan tampilan modern dan performa yang optimal. ${APP_NAME} hadir dengan fitur-fitur unggulan yang dirancang khusus untuk memaksimalkan pengalaman Anda setiap hari. 🐲💎

Fitur Unggulan:
🎯 Tampilan Modern: Antarmuka yang bersih dan responsif untuk kenyamanan bermain.
⚡ Akses Cepat: Performa aplikasi yang dioptimalkan, ringan dan cepat dibuka.
🔒 Aman & Terpercaya: Sistem keamanan berlapis untuk melindungi akun Anda.
📱 Multi Platform: Tersedia di semua perangkat, kapan saja dan di mana saja.
💰 Bonus Menarik: Dapatkan bonus dan reward eksklusif setiap hari.

Bergabunglah dengan jutaan pengguna yang sudah merasakan manfaatnya. Install sekarang dan mulai petualangan seru Anda bersama ${APP_NAME}! 🔥💰`;

const REVIEWS = [
  { name: 'Budi Santoso',  text: 'Aplikasi terbaik yang pernah aku coba, mudah digunakan!' },
  { name: 'Siti Rahayu',   text: 'Tampilan keren dan cepat, sangat direkomendasikan!' },
  { name: 'Andi Pratama',  text: 'Bonus setiap hari bikin makin semangat, mantap!' },
  { name: 'Dewi Lestari',  text: 'Akhirnya nemu aplikasi yang beneran bisa dipercaya. Joss!' },
  { name: 'Rizky Hidayat', text: 'Performa bagus, tidak lag sama sekali. Top!' },
];

const TAGS = ['Game', 'Kasual', 'Strategi', '18+'];

// ─── Component ────────────────────────────────────────────────────────────────
@customElement('app-home')
export class AppHome extends LitElement {

  @state() private countdown = 10;
  @state() private descExpanded = false;
  @state() private showPopup = false;

  private deferredPrompt: any = null;
  private countdownTimer: ReturnType<typeof setInterval> | null = null;

  static styles = css`
    :host {
      display: block;
      background: #f1f3f4;
      min-height: 100vh;
      font-family: 'Google Sans', Roboto, Arial, sans-serif;
    }

    /* ── Header ── */
    .lp-header {
      background: #fff;
      padding: 10px 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #e0e0e0;
    }
    .lp-header-brand {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .lp-header-icon {
      width: 32px;
      height: 32px;
      border-radius: 8px;
      object-fit: cover;
    }
    .lp-header-title {
      font-size: 15px;
      font-weight: 700;
      color: #202124;
      letter-spacing: 0.2px;
    }
    .top-dev-badge {
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 12px;
      font-weight: 600;
      color: #5f6368;
    }
    .top-dev-badge .trophy { font-size: 18px; }

    /* ── App info ── */
    .app-info {
      background: #fff;
      padding: 16px;
      display: flex;
      gap: 14px;
      align-items: flex-start;
    }
    .app-icon {
      width: 72px;
      height: 72px;
      border-radius: 14px;
      object-fit: cover;
      flex-shrink: 0;
      border: 1px solid #e0e0e0;
    }
    .app-meta h1 {
      margin: 0 0 3px 0;
      font-size: 18px;
      font-weight: 700;
      color: #202124;
      line-height: 1.2;
    }
    .app-meta .dev-name {
      margin: 0 0 5px 0;
      font-size: 13px;
      color: #01875f;
      font-weight: 500;
    }
    .app-meta .verified {
      font-size: 12px;
      color: #5f6368;
      display: flex;
      align-items: center;
      gap: 3px;
    }
    .verified-check {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 14px;
      height: 14px;
      background: #01875f;
      border-radius: 50%;
      color: #fff;
      font-size: 9px;
      font-weight: 700;
    }

    /* ── Stats ── */
    .stats-row {
      background: #fff;
      display: flex;
      border-top: 1px solid #f1f3f4;
    }
    .stat-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 12px 4px;
    }
    .stat-item + .stat-item {
      border-left: 1px solid #e0e0e0;
    }
    .stat-value {
      font-size: 14px;
      font-weight: 700;
      color: #202124;
      white-space: nowrap;
    }
    .stat-value.with-star::after {
      content: ' ★';
      color: #01875f;
    }
    .stat-label {
      font-size: 11px;
      color: #5f6368;
      margin-top: 2px;
      text-align: center;
    }

    /* ── Install button ── */
    .install-section {
      background: #fff;
      padding: 12px 16px 16px;
    }
    .install-btn {
      width: 100%;
      background: #01875f;
      color: #fff;
      border: none;
      border-radius: 8px;
      padding: 14px;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 3px;
      box-sizing: border-box;
      transition: background 0.15s, transform 0.1s;
      -webkit-tap-highlight-color: transparent;
    }
    .install-btn:hover  { background: #017353; }
    .install-btn:active { background: #015f47; transform: scale(0.99); }
    .btn-main {
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 0.3px;
    }
    .btn-sub {
      font-size: 12px;
      opacity: 0.85;
      font-weight: 400;
    }

    /* ── Screenshots ── */
    .screenshots-section {
      background: #fff;
      margin-top: 8px;
      padding: 14px 0 14px 16px;
    }
    .screenshots-list {
      display: flex;
      gap: 8px;
      overflow-x: auto;
      scrollbar-width: none;
      padding-right: 16px;
      -webkit-overflow-scrolling: touch;
    }
    .screenshots-list::-webkit-scrollbar { display: none; }
    .screenshot-img {
      height: 160px;
      border-radius: 8px;
      flex-shrink: 0;
      object-fit: cover;
      border: 1px solid #e0e0e0;
      cursor: pointer;
    }

    /* ── About ── */
    .about-section {
      background: #fff;
      margin-top: 8px;
      padding: 16px;
    }
    .section-title {
      font-size: 16px;
      font-weight: 700;
      color: #202124;
      margin: 0 0 10px 0;
    }
    .description {
      font-size: 14px;
      color: #3c4043;
      line-height: 1.65;
      white-space: pre-line;
    }
    .description.collapsed {
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .see-more-btn {
      background: none;
      border: none;
      color: #01875f;
      font-size: 14px;
      font-weight: 600;
      padding: 8px 0 0;
      cursor: pointer;
      display: block;
    }

    /* ── Tags ── */
    .tags-row {
      background: #fff;
      padding: 4px 16px 16px;
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
    }
    .tag {
      background: #f1f3f4;
      border: 1px solid #dadce0;
      border-radius: 16px;
      padding: 5px 12px;
      font-size: 12px;
      color: #3c4043;
      font-weight: 500;
    }

    /* ── Ratings ── */
    .ratings-section {
      background: #fff;
      margin-top: 8px;
      padding: 16px;
    }
    .ratings-header {
      margin-bottom: 14px;
    }
    .ratings-header h3 {
      margin: 0 0 3px;
      font-size: 16px;
      font-weight: 700;
      color: #202124;
    }
    .ratings-header p {
      margin: 0;
      font-size: 12px;
      color: #5f6368;
    }
    .ratings-body {
      display: flex;
      align-items: center;
      gap: 16px;
    }
    .rating-big {
      text-align: center;
      flex-shrink: 0;
    }
    .rating-num {
      font-size: 52px;
      font-weight: 300;
      color: #202124;
      line-height: 1;
    }
    .rating-stars {
      color: #01875f;
      font-size: 16px;
      letter-spacing: 1px;
    }
    .rating-count {
      font-size: 12px;
      color: #5f6368;
      margin-top: 2px;
    }
    .bars-col {
      flex: 1;
    }
    .bar-row {
      display: flex;
      align-items: center;
      gap: 6px;
      margin-bottom: 5px;
    }
    .bar-num {
      font-size: 11px;
      color: #5f6368;
      width: 8px;
      text-align: right;
      flex-shrink: 0;
    }
    .bar-track {
      flex: 1;
      height: 5px;
      background: #e0e0e0;
      border-radius: 3px;
      overflow: hidden;
    }
    .bar-fill {
      height: 100%;
      background: #01875f;
      border-radius: 3px;
    }

    /* ── Review list ── */
    .reviews-list {
      list-style: none;
      margin: 12px 0 0;
      padding: 0;
    }
    .review-item {
      padding: 10px 0;
      border-top: 1px solid #f1f3f4;
    }
    .review-name {
      font-size: 13px;
      font-weight: 700;
      font-style: italic;
      color: #202124;
    }
    .review-stars {
      color: #01875f;
      font-size: 12px;
      margin: 2px 0 3px;
    }
    .review-text {
      font-size: 13px;
      color: #3c4043;
      line-height: 1.5;
    }
    .see-all-btn {
      display: block;
      width: 100%;
      background: none;
      border: 1px solid #dadce0;
      border-radius: 8px;
      padding: 11px;
      color: #01875f;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      margin-top: 14px;
      box-sizing: border-box;
    }

    /* ── Footer ── */
    .lp-footer {
      background: #fff;
      margin-top: 8px;
      padding: 16px;
      font-size: 12px;
      color: #5f6368;
      text-align: center;
    }
    .lp-footer a {
      color: #01875f;
      text-decoration: none;
    }

    /* ── Install Popup ── */
    .popup-overlay {
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.55);
      display: flex;
      align-items: flex-end;
      justify-content: center;
      z-index: 1000;
      animation: fadeIn 0.2s ease;
    }
    @keyframes fadeIn {
      from { opacity: 0; }
      to   { opacity: 1; }
    }
    .popup-card {
      background: #fff;
      border-radius: 20px 20px 0 0;
      padding: 24px 20px 32px;
      width: 100%;
      max-width: 480px;
      box-sizing: border-box;
      animation: slideUp 0.25s ease;
    }
    @keyframes slideUp {
      from { transform: translateY(60px); opacity: 0; }
      to   { transform: translateY(0);    opacity: 1; }
    }
    .popup-handle {
      width: 36px;
      height: 4px;
      background: #dadce0;
      border-radius: 2px;
      margin: 0 auto 20px;
    }
    .popup-icon {
      display: block;
      width: 64px;
      height: 64px;
      border-radius: 14px;
      object-fit: cover;
      margin: 0 auto 12px;
      border: 1px solid #e0e0e0;
    }
    .popup-title {
      text-align: center;
      font-size: 18px;
      font-weight: 700;
      color: #202124;
      margin: 0 0 6px;
    }
    .popup-subtitle {
      text-align: center;
      font-size: 13px;
      color: #5f6368;
      margin: 0 0 24px;
      line-height: 1.5;
    }
    .popup-actions {
      display: flex;
      gap: 10px;
    }
    .popup-btn-cancel {
      flex: 1;
      background: none;
      border: 1px solid #dadce0;
      border-radius: 8px;
      padding: 13px;
      font-size: 15px;
      font-weight: 600;
      color: #5f6368;
      cursor: pointer;
    }
    .popup-btn-install {
      flex: 2;
      background: #01875f;
      border: none;
      border-radius: 8px;
      padding: 13px;
      font-size: 15px;
      font-weight: 700;
      color: #fff;
      cursor: pointer;
      transition: background 0.15s;
    }
    .popup-btn-install:hover  { background: #017353; }
    .popup-btn-install:active { background: #015f47; }

    /* ── Responsive ── */
    @media (min-width: 600px) {
      :host { max-width: 480px; margin: 0 auto; display: block; }
    }
  `;

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('beforeinstallprompt', this._onBeforeInstall);
    this._startCountdown();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('beforeinstallprompt', this._onBeforeInstall);
    if (this.countdownTimer) clearInterval(this.countdownTimer);
  }

  private _onBeforeInstall = (e: Event) => {
    e.preventDefault();
    this.deferredPrompt = e;
  };

  private _startCountdown() {
    this.countdownTimer = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(this.countdownTimer!);
        this.countdownTimer = null;
        this.showPopup = true;
      }
    }, 1000);
  }

  private async _doInstall() {
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt();
      await this.deferredPrompt.userChoice;
      this.deferredPrompt = null;
    } else {
      window.location.href = REDIRECT_URL;
    }
  }

  private _onInstallClick() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
    this.showPopup = true;
  }

  private _onPopupInstall() {
    this.showPopup = false;
    this._doInstall();
  }

  private _onPopupCancel() {
    this.showPopup = false;
  }

  render() {
    return html`
      <!-- Header -->
      <header class="lp-header">
        <div class="lp-header-brand">
          <img class="lp-header-icon" src="${APP_ICON}" alt="${APP_NAME}" />
          <span class="lp-header-title">${APP_NAME}</span>
        </div>
        <div class="top-dev-badge">
          <span class="trophy">🏆</span>
          <span>Top Developer</span>
        </div>
      </header>

      <!-- App info -->
      <div class="app-info">
        <img class="app-icon" src="${APP_ICON}" alt="${APP_NAME}" />
        <div class="app-meta">
          <h1>${APP_NAME}</h1>
          <p class="dev-name">${APP_DEV}</p>
          <span class="verified">
            <span class="verified-check">✓</span>
            Verified by App
          </span>
        </div>
      </div>

      <!-- Stats -->
      <div class="stats-row">
        <div class="stat-item">
          <span class="stat-value with-star">${RATING}</span>
          <span class="stat-label">${REVIEW_COUNT} Reviews</span>
        </div>
        <div class="stat-item">
          <span class="stat-value">${DOWNLOADS}</span>
          <span class="stat-label">Downloads</span>
        </div>
        <div class="stat-item">
          <span class="stat-value">${AGE_RATING}</span>
          <span class="stat-label">Rated for ${AGE_RATING}</span>
        </div>
      </div>

      <!-- Install button -->
      <div class="install-section">
        <button class="install-btn" @click="${this._onInstallClick}">
          <span class="btn-main">⚡ Install</span>
          <span class="btn-sub">
            ${this.countdown > 0
              ? html`Download in ${this.countdown}s`
              : html`Installing...`}
          </span>
        </button>
      </div>

      <!-- Screenshots -->
      <div class="screenshots-section">
        <ul class="screenshots-list" style="list-style:none;margin:0;padding:0">
          ${SCREENSHOTS.map(src => html`
            <li style="display:contents">
              <img class="screenshot-img" src="${src}" alt="Screenshot" loading="lazy" />
            </li>
          `)}
        </ul>
      </div>

      <!-- About -->
      <div class="about-section">
        <h2 class="section-title">About this app</h2>
        <div class="description ${this.descExpanded ? '' : 'collapsed'}">${DESCRIPTION}</div>
        <button class="see-more-btn"
          @click="${() => { this.descExpanded = !this.descExpanded; }}">
          ${this.descExpanded ? 'See less' : 'See more'}
        </button>
      </div>

      <!-- Tags -->
      <div class="tags-row">
        ${TAGS.map(t => html`<span class="tag">${t}</span>`)}
      </div>

      <!-- Ratings & Reviews -->
      <div class="ratings-section">
        <div class="ratings-header">
          <h3>Ratings and reviews</h3>
          <p>The grades and assessments are checked</p>
        </div>
        <div class="ratings-body">
          <div class="rating-big">
            <div class="rating-num">${RATING}</div>
            <div class="rating-stars">★★★★★</div>
            <div class="rating-count">${REVIEW_COUNT}</div>
          </div>
          <div class="bars-col">
            ${([[5, 94], [4, 4], [3, 1], [2, 0], [1, 1]] as [number, number][]).map(([n, pct]) => html`
              <div class="bar-row">
                <span class="bar-num">${n}</span>
                <div class="bar-track">
                  <div class="bar-fill" style="width:${pct}%"></div>
                </div>
              </div>
            `)}
          </div>
        </div>

        <ul class="reviews-list">
          ${REVIEWS.map(r => html`
            <li class="review-item">
              <div class="review-name">${r.name}</div>
              <div class="review-stars">★★★★★</div>
              <div class="review-text">${r.text}</div>
            </li>
          `)}
        </ul>
        <button class="see-all-btn">See all reviews</button>
      </div>

      <!-- Install Popup -->
      ${this.showPopup ? html`
        <div class="popup-overlay" @click="${(e: Event) => { if (e.target === e.currentTarget) this._onPopupCancel(); }}">
          <div class="popup-card">
            <div class="popup-handle"></div>
            <img class="popup-icon" src="${APP_ICON}" alt="${APP_NAME}" />
            <h2 class="popup-title">Install ${APP_NAME}?</h2>
            <p class="popup-subtitle">Tambahkan ke layar utama untuk akses cepat kapan saja dan di mana saja.</p>
            <div class="popup-actions">
              <button class="popup-btn-cancel" @click="${this._onPopupCancel}">Tidak</button>
              <button class="popup-btn-install" @click="${this._onPopupInstall}">⚡ Install Sekarang</button>
            </div>
          </div>
        </div>
      ` : null}

      <!-- Footer -->
      <footer class="lp-footer">
        The final result is not guaranteed &nbsp;|&nbsp;
        <a href="mailto:support@rokokbet.com">Contact us</a>
      </footer>
    `;
  }
}
